interface LoadingFallbackProps {
  className?: string
}

export function LoadingFallback({ className = "" }: LoadingFallbackProps) {
  return (
		<div className={`${className} w-full h-full`}>
			<LoadingSpinner />
		</div>
	);
}

export function LoadingSpinner({ size = "sm" }: { size?: "sm" | "md" | "lg" }) {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-6 w-6", 
    lg: "h-8 w-8"
  }
  
  return (
    <div className={`animate-spin rounded-full ${sizeClasses[size]} border-2 border-primary border-t-transparent`} />
  )
}